import { FC } from 'react'
import {
  Datagrid, DateField, FilterList, FilterListItem, FunctionField, List,
  TextField, useTranslate,
} from 'react-admin'
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew'
import PublicIcon from '@mui/icons-material/Public'
import { Chip } from '@mui/material'
import { EnabledChip, FilterAside } from '../../components'
import { AutomationRuleOut } from '../../types/apiRequests'
import { getPerPage } from '../../utils/usePerPage'

const AutomationRuleFilters: FC = () => {
  const translate = useTranslate()
  return (
    <FilterAside>
      <FilterList label={translate('filters.status')} icon={<PowerSettingsNewIcon />}>
        <FilterListItem label="filters.active" value={{ enabled: true }} />
        <FilterListItem label="filters.inactive" value={{ enabled: false }} />
      </FilterList>

      <FilterList label={translate('filters.scope')} icon={<PublicIcon />}>
        <FilterListItem label="automationRule.scopeGlobal" value={{ scope: 'global' }} />
        {/* eslint-disable-next-line camelcase */}
        <FilterListItem label="automationRule.scopeSpecific" value={{ scope: 'specific_organizations' }} />
      </FilterList>
    </FilterAside>
  )
}

const AutomationRuleList: FC = () => {
  const translate = useTranslate()

  // eslint-disable-next-line camelcase
  const SCOPE_LABELS: Record<string, string> = {
    global: translate('automationRule.scopeGlobal'),
    // eslint-disable-next-line camelcase
    specific_organizations: translate('automationRule.scopeSpecific'),
  }

  return (
    <List
      exporter={false}
      sort={{ field: 'created', order: 'DESC' }}
      perPage={getPerPage()}
      aside={<AutomationRuleFilters />}
    >
      <Datagrid bulkActionButtons={false} rowClick="show">
        <TextField source="display_name" label="data.displayName" />
        <FunctionField<AutomationRuleOut>
          label="automationRule.scope"
          render={(record) =>
            // eslint-disable-next-line security/detect-object-injection
            SCOPE_LABELS[record.scope] ?? record.scope
          }
        />
        <FunctionField<AutomationRuleOut>
          label="automationRule.triggers"
          render={(record) => (
            <Chip label={record.triggers?.length ?? 0} size="small" sx={{ fontWeight: 600, fontSize: 11, height: 22 }} />
          )}
        />
        <FunctionField<AutomationRuleOut>
          label="data.actions"
          render={(record) => (
            <Chip label={record.actions?.length ?? 0} size="small" sx={{ fontWeight: 600, fontSize: 11, height: 22 }} />
          )}
        />
        <FunctionField<AutomationRuleOut> label="data.enabled" render={() => <EnabledChip />} />
        <DateField source="last_triggered" showTime label="data.lastTriggered" />
        <DateField source="created" showTime label="data.createdAt" />
      </Datagrid>
    </List>
  )
}

export default AutomationRuleList
